import { SolType } from '@sol/components';
import { WebContentAnnotation } from './web-content-annotation.models';

export class WebContentAnnotationType {
  public static readonly annotation = SolType.ofObject<WebContentAnnotation>('webContentV2.annotation', {
    id: SolType.string,
    text: SolType.string,
    user: SolType.string,
    date: SolType.date,
  });
}
